"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
(function() {
  if (!customElements.get("swiper-slider")) {
    const BREAKPOINTS = {
      sm: 750,
      lg: 1024
    };
    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        __publicField(this, "initSwiper", () => {
          const slides = this.querySelectorAll(".swiper-slide");
          const slidesLength = slides.length;
          let { slidesPerView = 1, slidesPerViewSm, slidesPerViewLg, effect } = this.dataset;
          if (!slidesPerViewSm) slidesPerViewSm = slidesPerView;
          if (!slidesPerViewLg) slidesPerViewLg = slidesPerView;
          slidesPerView = slidesLength < +slidesPerView ? slidesLength : +slidesPerView;
          slidesPerViewSm = slidesLength < +slidesPerViewSm ? slidesLength : +slidesPerViewSm;
          slidesPerViewLg = slidesLength < +slidesPerViewLg ? slidesLength : +slidesPerViewLg;
          effect = effect || "slide";
          let scrollbar = false;
          if (this.scrollbar) {
            scrollbar = {
              el: ".swiper-scrollbar",
              draggable: true
            };
          }
          let navigation = false;
          if (this.nextBtn && this.prevBtn) {
            navigation = {
              nextEl: this.nextBtn,
              prevEl: this.prevBtn
            };
          }
          const swiperParams = {
            slidesPerView,
            scrollbar,
            navigation,
            effect,
            spaceBetween: 20,
            breakpoints: {
              [BREAKPOINTS.sm]: {
                slidesPerView: slidesPerViewSm,
                spaceBetween: 20
              },
              [BREAKPOINTS.lg]: {
                slidesPerView: slidesPerViewLg,
                spaceBetween: 30
              }
            },
            on: {
              slideChange: this.updateNavigationButtons,
              init: this.updateNavigationButtons
            }
          };
          if (effect === "fade") {
            swiperParams.fadeEffect = { crossFade: true };
          }
          this.swiper = new Swiper(this, swiperParams);
        });
        __publicField(this, "updateNavigationButtons", () => {
          var _a, _b, _c, _d;
          if (this.swiper) {
            if (this.swiper.isBeginning) {
              (_a = this.prevBtn) == null ? void 0 : _a.classList.add("disabled");
            } else {
              (_b = this.prevBtn) == null ? void 0 : _b.classList.remove("disabled");
            }
            if (this.swiper.isEnd) {
              (_c = this.nextBtn) == null ? void 0 : _c.classList.add("disabled");
            } else {
              (_d = this.nextBtn) == null ? void 0 : _d.classList.remove("disabled");
            }
          }
        });
        this.swiper = null;
      }
      connectedCallback() {
        this.nextBtn = this.querySelector(".swiper-button-next");
        this.prevBtn = this.querySelector(".swiper-button-prev");
        this.scrollbar = this.querySelector(".swiper-scrollbar");
        this.initSwiper();
        this.updateNavigationButtons();
      }
    }
    customElements.define("swiper-slider", SwiperSlider);
  }
})();
